import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-oauth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslatePipe],
  templateUrl: './oauth-layout.component.html',
  styleUrl: './oauth-layout.component.scss',
})
export class OAuthLayoutComponent {}
